import { render, staticRenderFns } from "./ProjectsContracts.vue?vue&type=template&id=15d718c8&scoped=true&lang=html&"
import script from "./ProjectsContracts.vue?vue&type=script&lang=js&"
export * from "./ProjectsContracts.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsContracts.vue?vue&type=style&index=0&id=15d718c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d718c8",
  null
  
)

export default component.exports